import type { JSX } from 'react';
import { OTPInput, REGEXP_ONLY_DIGITS, type SlotProps } from 'input-otp';

interface OtpInputProps {
  value: string;
  onChange: (value: string) => void;
  maxLength?: number;
  hasError?: boolean;
  onComplete?: (value: string) => void;
}

const Slot = ({ char, isActive, hasFakeCaret }: SlotProps): JSX.Element => (
  <div className={`otp-slot${isActive ? ' otp-slot--active' : ''}${char ? ' otp-slot--filled' : ''}`}>
    {hasFakeCaret ? <div className='otp-caret' /> : char}
  </div>
);

export const OtpInput = ({
  value,
  onChange,
  maxLength = 6,
  hasError = false,
  onComplete,
}: OtpInputProps): JSX.Element => (
  <OTPInput
    value={value}
    onChange={onChange}
    maxLength={maxLength}
    pattern={REGEXP_ONLY_DIGITS}
    onComplete={onComplete}
    name='otp'
    inputMode='numeric'
    containerClassName={`otp-container${hasError ? ' otp-container--error' : ''}`}
    render={({ slots }) => (
      <div className='otp-group'>
        {slots.map((slot, index) => (
          <Slot key={index} {...slot} />
        ))}
      </div>
    )}
  />
);
